const faqList = [
    {
      question: "What is Brazilian Jiu-Jitsu (BJJ)?",
      answer: "Brazilian Jiu-Jitsu (BJJ) is a grappling-based martial art that focuses on ground fighting and submissions. It emphasizes leverage, technique, and strategy over brute strength, making it highly effective for people of all sizes."
    },
    {
      question: "Do I need experience to start?",
      answer: "No, you don’t need any prior experience to start training at Maple Jiu-Jitsu. Our classes are designed for all skill levels, from beginners to advanced practitioners."
    },
    {
      question: "Is it safe to train at Maple BJJ?",
      answer: "Yes, we prioritize safety and promote a safe, supportive environment. Our instructors are experienced in ensuring that all training is conducted with care, minimizing the risk of injury."
    },
    {
      question: "What should I wear to class?",
      answer: "For No-Gi classes, you should wear shorts and a rashguard. For Gi classes, you will need a Gi, which we also offer for purchase at the academy."
    },
    {
      question: "Do you offer a free trial?",
      answer: "For those looking to try a class for the first time we have a promotional drop in rate of $20, which will be applied towards your membership if you decide to sign up. Lets face it, $20 is a negligible amount in today's economy."
    },
    {
      question: "What age groups can sign up?",
      answer: "We accept students aged 4 and up, boys & girls, men & women, regardless of experience level."
    },
  ];

  export default faqList;
  